import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b342420"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "menu-item px-3" }
const _hoisted_2 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_3 = { class: "symbol symbol-50px me-5" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_6 = {
  class: "text-truncate text-name",
  style: {"max-width":"120px"}
}
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1))
const _hoisted_9 = { class: "menu-item px-5" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" My Profile ")
const _hoisted_11 = { class: "menu-item px-5" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Settings ")
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1))
const _hoisted_14 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-sm-100", { show: _ctx.show }]),
    "data-kt-menu": "true"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Avatar, {
            imageFile: _ctx.image,
            useIcon: false,
            acronym: _ctx.acronym,
            size: "40"
          }, null, 8, ["imageFile", "acronym"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.userName), 1)
          ]),
          _createElementVNode("a", {
            href: _ctx.mailTo,
            class: "fw-bold text-muted text-hover-primary fs-7 text-truncate text-capitalize text-role",
            style: {"max-width":"160px"}
          }, _toDisplayString(_ctx.userRoles), 9, _hoisted_7)
        ])
      ])
    ]),
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: "/profile/overview",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_router_link, {
        to: "/settings",
        class: "menu-link px-5"
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      })
    ]),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ], 2))
}